const CONST_VARIANT = {
  MUI_DEFAULT: 'MUI_DEFAULT',
  KC_DEFAULT: 'KC_DEFAULT',
  DISABLED: 'DISABLED',
}

const MUI_LICENSE = '8f188f0eced2e255a8cdc30a395aa8cfTz03MzQ3NSxFPTE3MjQ2MTg1MjIwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixLVj0y';

export { CONST_VARIANT, MUI_LICENSE };